module.exports = __webpack_public_path__ + "static/media/move-money.de61f768.png";